import React from 'react';
import classnames from 'classnames';

import styles from './index.module.scss';

const Video = () => (
  <div className={classnames(styles.blueBackground)}>
    <div className={classnames(styles.title)}>This is Indorse</div>
    <div className={classnames(styles.subtitle)}>
      Powered by industry experts. Empowering everyone.
    </div>

    <div className={classnames(styles.videoContainer, 'col-lg-8 col-12 px-0 pt-2')}>
      <div
        className={classnames(styles.videoWrapper)}
        dangerouslySetInnerHTML={{
          __html: `<iframe
            src="https://www.youtube.com/embed/CBs1JJe9Qr4"
            srcdoc="<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}img,span{position:absolute;width:100%;top:0;bottom:0;margin:auto}span{height:1.5em;text-align:center;font:48px/1.5 sans-serif;color:white;text-shadow:0 0 0.5em black}</style><a href=https://www.youtube.com/embed/CBs1JJe9Qr4?autoplay=1><img src=https://img.youtube.com/vi/CBs1JJe9Qr4/maxresdefault.jpg alt='Explanation Video'><span>▶</span></a>"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            title="Indorse Explanation Video"
            ></iframe>`,
        }}
      />
    </div>
  </div>
);

export default Video;
